var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBenchmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 3C13.6687 3 15.2306 3.45519 16.5703 4.24658L15.4673 5.34961C14.4301 4.80777 13.2512 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 13.5103 4.94617 14.9139 5.71289 16.0898L4.45605 16.9102C3.53521 15.4978 3 13.81 3 12C3 7.02944 7.02944 3 12 3ZM19.752 7.42822C20.544 8.76829 21 10.3306 21 12C21 13.81 20.4648 15.4978 19.5439 16.9102L18.2871 16.0898C19.0538 14.9139 19.5 13.5103 19.5 12C19.5 10.7481 19.1913 9.56882 18.6489 8.53125L19.752 7.42822Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2803 5.78027L14.0273 11.0317C14.1679 11.3254 14.25 11.6527 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C12.3466 9.75 12.6736 9.8312 12.9668 9.97119L18.2197 4.71973L19.2803 5.78027Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBenchmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/benchmark.762c5e4de827c8b00ae62b9555aff3b9.svg";